import Http from './config'

export const getSearchList = data => Http.get({
  url: 'search',
  params: data
})

export const getCategoryList = data => Http.post({
  url: 'category/list',
  params: data
})

export const getQuestionList = data => Http.post({
  url: 'question/list',
  params: data
})

export const getQuestionById = data => Http.post({
  url: 'question/id',
  params: data
})

export const getCustomerServiceList = data => Http.post({
  url: 'seatList',
  params: data
})

export const setUploadFile = data => Http.post({
  contentType: 'multipart',
  url: 'uploadFile4IM',
  params: data
})

export const setStatistics = data => Http.post({
  url: 'intoAppletPage',
  params: data
})

export const selectAppletOperate = async () => {
  console.log('🔍 [Database] 开始查询客服时间配置')
  try {
    const result = await Http.post({
      url: 'selectAppletOperate',
    })
    console.log('🔍 [Database] 查询结果:', result)
    return result
  } catch (error) {
    console.error('❌ [Database] 查询客服时间配置失败:', error)
    // 返回默认配置
    const defaultConfig = {
      startTime: '8:00',
      endTime: '21:00',
      message: '抱歉，客服繁忙，若有问题，请致电96510咨询。'
    }
    console.log('🔍 [Database] 使用默认配置:', defaultConfig)
    return defaultConfig
  }
}

export const submitFeedback = data => Http.post({
  url: 'public/feedback/submit',
  params: data
})



// WEBPACK FOOTER //
// ./src/database/index.js